import { useEffect } from "react";

import { datadogRum } from "@datadog/browser-rum";

export function TimingMark({ name }: { name: string }) {
  useEffect(() => {
    datadogRum.addTiming(name);
  }, [name]);

  return null;
}
